  <template>
  <div class="center">
    <vs-dialog
      class="success-modal"
      not-center
      overflow-hidden
      v-model="active"
    >
      <template #header>
      </template>
      <div class="con-content container">
        <div class="">
          <img src="@/assets/icons/done-all.svg" alt style="width:36px; margin-bottom:20px" />
          <div class="medium-18">ขอบคุณที่สนใจ Fractional Property</div>
          <div class="medium-darkgrey-18">ทางเราจะติดต่อกลับไปโดยเร็วที่สุด</div>
        </div>
      </div>
    </vs-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: false,
    active2: false,
    active3: false,
    input1: ''
  }),
  methods: {
    openModal() {
      this.active = true
    }
  }
}
</script>

<style scoped>
@import '../styles/App.css';

.success-modal >>> .vs-dialog__header {
  padding: 0px;
}

.success-modal >>> .vs-dialog__content {
  height: inherit;
}

.modal-header {
  background-color: #533d67;
  justify-content: center;
}

.not-margin {
  margin: 0px;
  border-top-left-radius: var(--vs-radius);
}

.con-content {
  text-align: center;
}
</style>
